import { Stack } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LiquidGlassCircleButton } from '../common/LiquidGlassCircleButton';
import { LiquidGlassSearchBar } from '../common/LiquidGlassSearchBar';

interface CategorySearchEditRowProps {
  searchOpen: boolean;
  searchQuery: string;
  onSearchQueryChange: (value: string) => void;
  onOpenSearch: () => void;
  onCloseSearch: () => void;
  showEditButton: boolean;
  onEditCategory: () => void;
}

export const CategorySearchEditRow: FC<CategorySearchEditRowProps> = ({
  searchOpen,
  searchQuery,
  onSearchQueryChange,
  onOpenSearch,
  onCloseSearch,
  showEditButton,
  onEditCategory,
}) => {
  const { t } = useTranslation();
  return <Stack direction="row" alignItems="center" justifyContent={searchOpen ? 'flex-start' : 'flex-end'} gap="10px" px={2} pb={2}>
    {searchOpen ? (
      <LiquidGlassSearchBar
        value={searchQuery}
        onChange={onSearchQueryChange}
        onClose={onCloseSearch}
        placeholder={t('category.searchPlaceholder')}
        ariaLabel={t('category.search')}
        height={44}
      />
    ) : (
      <LiquidGlassCircleButton icon="search" ariaLabel={t('category.search')} onClick={onOpenSearch} size={44} iconSize={20} />
    )}
    {showEditButton && (
      <LiquidGlassCircleButton icon="edit" ariaLabel={t('category.edit')} onClick={onEditCategory} size={44} iconSize={20} />
    )}
  </Stack>;
};
